module.exports = "/_next/static/videos/bikes-1-96ad7eaf9a7bdc0ef951f4eccfb94f82.webm";